import {
  FromCreationType,
  ActionStack,
  CREATE_FORMS,
  UPDATE_PROPERTIES,
  ADD_FORMS,
  UNDO,
  REDO,
  INITIALIZE_ACTION_STACK,
  PUSH_ACTION_STACK,
  ADD_THEME_INFO,
  AUTO_COMPLETE_VARIABLES,
  SAVE_ORIGINAL_FORM_DATA,
  SET_SELECTED_FORM_DATA,
  REMOVE_FORM,
  UPDATE_FORM_WIDGET_PROPERTIES
} from './types';

const initialState: ActionStack = {
  actionStack: [],
  actionPointer: 0,
  autoCompleteVariables: [],
  formData: {},
  selectedForm:{}
};

export function formJsonCreation(
  state: any = initialState,
  action: FromCreationType
) {
  switch (action.type) {
    case INITIALIZE_ACTION_STACK:
      return {
        ...state,
        actionPointer: 0,
        actionStack: [],
      };
    case PUSH_ACTION_STACK:
      const actionStackCopy = [...state.actionStack];
      actionStackCopy.splice(
        state.actionPointer,
        actionStackCopy.length,
        action.data
      );
      return {
        ...state,
        actionPointer: actionStackCopy.length,
        actionStack: actionStackCopy,
      };
    case UNDO:
      return {
        ...state,
        actionPointer: state.actionPointer - 1,
      };
    case REDO:
      return {
        ...state,
        actionPointer: state.actionPointer + 1,
      };
    case CREATE_FORMS:
    case ADD_FORMS:
    case UPDATE_PROPERTIES:
    case ADD_THEME_INFO:
      return {
        ...state,
        [action.data.id]: action.data.data,
      };
    case UPDATE_FORM_WIDGET_PROPERTIES:
      return {
        ...state,
        [action.data.formid]: action.data.result
      };
    case SAVE_ORIGINAL_FORM_DATA:
      return {
        ...state,
        formData: action.data
      }
    case AUTO_COMPLETE_VARIABLES:
      return {
        ...state,
        autoCompleteVariables: action.data,
      };
    case SET_SELECTED_FORM_DATA:
      return {
        ...state,
        selectedForm: action.data[0],
      };
    case REMOVE_FORM:
      let data = {...state};
      delete data[action.data.id]
      return data
    default:
      return state;
  }
}
